import { SearchDataStructure, AttributeTypes } from '../ui/components';

const mockDataSingleOption: SearchDataStructure[] = [
  {
    name: 'Attribute Name',
    key: 'attributeName',
    type: AttributeTypes.DropdownSingleSelect,
    visibility: true,
    dataset: [
      {
        key: 'productId',
        value: 'productId',
      },
      {
        key: 'aliasCode',
        value: 'aliasCode',
      },
    ],
  },
  {
    name: 'Attribute Value',
    key: 'attributeValue',
    type: AttributeTypes.Textbox,
    visibility: true,
  },
  {
    name: 'Language',
    key: 'language',
    type: AttributeTypes.DropdownSingleSelect,
    visibility: false,
    dataset: [
      {
        key: 'en',
        value: 'English',
      },
      {
        key: 'th',
        value: 'Thai',
      },
    ],
  },
];
const mockDataUserSingleOption: SearchDataStructure[] = [
  {
    name: 'Login ID',
    key: 'loginId',
    type: AttributeTypes.Textbox,
    visibility: true,
  },
  {
    name: 'Name',
    key: 'name',
    type: AttributeTypes.Textbox,
    visibility: true,
  },
  {
    name: 'Email',
    key: 'email',
    type: AttributeTypes.Textbox,
    visibility: true,
  },
  {
    name: 'Phone Number',
    key: 'phone',
    type: AttributeTypes.TextboxNumber,
    labelInfo: 'Exclude country code',
    visibility: false,
  },
  {
    name: 'Role',
    key: 'frameworkRole',
    type: AttributeTypes.DropdownSingleSelect,
    visibility: false,
    dataset: [
      {
        key: 'ADMIN',
        value: 'Admin',
      },
      {
        key: 'MEMBER',
        value: 'Member',
      },
    ],
  },
  // {
  //   name: 'Member Type',
  //   key: 'memberType',
  //   type: AttributeTypes.DropdownMultiSelect,
  //   visibility: false,
  //   allSelectionOption: true,
  //   dataset: [
  //     {
  //       key: 'INDIVIDUAL',
  //       value: 'INDIVIDUAL',
  //     },
  //     {
  //       key: 'COUPLE',
  //       value: 'COUPLE',
  //     },
  //     {
  //       key: 'INDIVIDUAL_INVISIBLE',
  //       value: 'INDIVIDUAL_INVISIBLE',
  //     },
  //   ],
  // },
  // {
  //   name: 'User ID',
  //   key: 'userId',
  //   type: AttributeTypes.Textbox,
  //   visibility: false,
  // },
  // {
  //   name: 'Primary User',
  //   key: 'isPrimary',
  //   type: AttributeTypes.DropdownSingleSelect,
  //   visibility: false,
  //   dataset: [
  //     {
  //       key: 'true',
  //       value: 'True',
  //     },
  //     {
  //       key: 'false',
  //       value: 'False',
  //     },
  //   ],
  // },
];
const campaignSearchOptions: SearchDataStructure[] = [
  {
    name: 'Campaign ID',
    key: 'campaignId',
    type: AttributeTypes.Textbox,
    visibility: true,
  },
  {
    name: 'Campaign Name',
    key: 'campaignName',
    type: AttributeTypes.Textbox,
    visibility: false,
  },
];
const mockDataMultipleOptions = [
  {
    name: 'Product id',
    key: 'product_id',
    type: 'textbox_numeric',
    visibility: true,
  },
  {
    name: 'Product Name',
    key: 'product_name',
    type: 'textbox',
    visibility: true,
  },
  {
    name: 'Testing Name',
    key: 'testing_name',
    type: 'textbox',
    visibility: true,
  },
  {
    name: 'Testing id',
    key: 'testing_id',
    type: 'textbox_numeric',
    visibility: false,
  },
  {
    name: 'Channel',
    key: 'channel',
    type: 'dropdown',
    visibility: true,
    dataset: [
      {
        key: 'web',
        value: 'Web',
      },
      {
        key: 'mobile',
        value: 'Mobile',
      },
    ],
  },
  {
    name: 'From date',
    key: 'fromdate',
    type: 'datetime_single',
    minDate: '01/05/2023',
    maxDate: '31/05/2023',
    visibility: false,
  },
  {
    name: 'Date Range',
    key: 'range_date',
    type: 'datetime_range',
    minDate: '01/05/2023',
    maxDate: '31/05/2023',
    visibility: false,
  },
];

// Story demo

const productStatusArray = ['Published', 'Staging'];

const productListMockEntry = () => ({
  productId: 'p0001',
  aliasCode: 1234,
  productName: 'XS Protein Pods - Choclate',
  channel: 'DEFAULT',
  vertical: 'Default',
  language: 'EN',
  createdDate: new Date('2023-03-03T00:00:00Z'),
  updatedDate: new Date('2023-03-05T00:00:00Z'),
  status: productStatusArray[Math.floor(Math.random() * productStatusArray.length)],
});

const productListMock = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map(() => productListMockEntry());

const userListMockEntry = (index: number) => {
  const userId = (index + 1).toString();
  const loginId = `ABO-${userId.toString().padStart(2, '0')}`;
  const role = Math.random() < 0.5 ? 'ADMIN' : 'MEMBER';
  const memberTypes = ['INDIVIDUAL', 'COUPLE', 'INDIVIDUAL_INVISIBLE'];
  const memberType = memberTypes[Math.floor(Math.random() * memberTypes.length)];
  const isPrimary = (Math.random() < 0.5).toString();
  const names = ['John', 'Jane', 'Bob', 'Alice', 'Charlie', 'Diana', 'Eva', 'Frank', 'Grace', 'Harry'];
  const name = names[Math.floor(Math.random() * names.length)];

  return {
    userId,
    loginId,
    role,
    memberType,
    isPrimary,
    name,
  };
};

const userListMock = Array.from({ length: 15 }, (_, index) => userListMockEntry(index));

export {
  mockDataSingleOption,
  mockDataMultipleOptions,
  productListMock,
  productStatusArray,
  userListMock,
  mockDataUserSingleOption,
  campaignSearchOptions,
};
